export const getMaxNumber = (field: any) =>
  field.tests.find((test: any) => test.OPTIONS.name === 'max').OPTIONS.params
    .max;
